var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"file_label",attrs:{"for":_vm.id}},[_vm._t("default"),_c('input',{attrs:{"id":_vm.id,"type":"file","accept":_vm.accept},on:{"change":_vm.change}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }